export * from './skyscraper7.component';